<template>
  <div v-if="isSupport" class="menu">
    <li
      class="list-group-item"
      v-on:click="isMenuOpened = !isMenuOpened"
    >
      <img class="menu-logo" :src="app_root + '/assets/common/img/printlink/browser.svg'" alt="webapp_print" align="middle">
      <LabelFunMessage fcontId="0" msgkey="103" />
      <span
        v-if="!isMenuOpened"
        class="glyphicon glyphicon-chevron-down"
        aria-hidden="true"
      ></span>
      <span
        v-if="isMenuOpened"
        class="glyphicon glyphicon-chevron-up"
        aria-hidden="true"
      >
      </span>
    </li>

    <collapse v-model="isMenuOpened" class="app-menu">
      <div class="app-menu-inner">
        <div class="app-message-area">
          <p class="app-message app-message-1">
            <LabelFunMessage fcontId="0" msgkey="104" />
          </p>
          <p class="app-message">
            <LabelFunMessage fcontId="0" msgkey="105" />
          </p>
          <div class="app_info">
            <img :src="app_root + '/assets/common/img/printlink/template_collection.svg'" />
            <p class="app_title">
              <LabelFunMessage fcontId="0" msgkey="131" />
            </p>
          </div>
          <p class="text-center modal-print-button">
            <a v-on:click="launchApp()" class="btn btn-info btn-lg" role="button">
              <LabelFunMessage fcontId="0" msgkey="106" />&nbsp;&raquo;
            </a>
          </p>
        </div>
        <div class="app-caution">
          <p>
            <LabelFunMessage fcontId="0" msgkey="107" />
          </p>
          <p>
            <LabelFunMessage fcontId="0" msgkey="108" />
          </p>
          <p>
            <a v-bind:href="this.recommendedEnvironmentsUrl" target="_blank" rel="noopener">
              <LabelFunMessage fcontId="0" msgkey="109" />
            </a>
          </p>
        </div>
      </div>
    </collapse>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { LAUNCH_TYPE, CONTENT_TYPE, PAPER_SIZE, PAPER_TYPE } from "@/common/contentsinfo";
import LabelFunMessage from "./LabelFunMessage";
import { Collapse } from "uiv";

// const URL_DOMAIN_DEV = "https://stg.gallery-contents.epsonconnect.com"
const URL_DOMAIN = "https://www.gallery-contents.epsonconnect.com"
const PRINTINGLIST_PAGE = "printing-list"
const NOT_DEFINE_FCONT_ID = "designpaper_samplepage"

// アプリ独自のカテゴリ
const DESIGNPAPER_CATEGORY_ALL = "all"
const DESIGNPAPER_CATEGORY_NEW = "new" 

// デザインペーパー新柄ページが更新されたら変更する
const LATEST_DESINGPAPER_ARTICLEID = "182"

export default {
  name: "PrintMenuWebApp",
  props: {
    launchType: String, // select, print
    contentType: String, // designPaper, photoLayout, nenga など
    categoryId: String, // designPaperの場合：xxx
    designId: String, // designPaperの場合：xx-xx
    mediaSizeId: String,
    mediaTypeId: String,
    fcontId: String,
  },
  data() {
    return {
      isMenuOpened: false,
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage,
    Collapse
  },
  computed: {
    ...mapState(["os","lg2"]),
    ...mapGetters(["isJpTemplate"]),
    isDesignPaperSupport: function () {
      if (this.isLocalChina){
        return false
      } else if (this.mediaSizeId == PAPER_SIZE.A4 && this.mediaTypeId == PAPER_TYPE.matte) {
        return false;
      } else {
        return true;
      }
    },
    isLocalChina: function () {
      return window.location.host == "support.epson.com.cn"
    },
    isSupport: function () {
      switch (this.contentType) {
        case CONTENT_TYPE.designpaper:
        case CONTENT_TYPE.designpaperPremiumCollection:
          return this.isDesignPaperSupport;
        case CONTENT_TYPE.nenga:
        case CONTENT_TYPE.postcard:
        case CONTENT_TYPE.photolayout:
        case CONTENT_TYPE.freeLayout:
        case CONTENT_TYPE.greetingCards:
        case CONTENT_TYPE.album:  
        case CONTENT_TYPE.photobook:
        case CONTENT_TYPE.createplusContents: 
        case CONTENT_TYPE.creativeTop:
        default:
          return false;
      }
    },
    articleLogId: function () {
      if (this.fcontId == undefined) {
        return NOT_DEFINE_FCONT_ID
      }else {
        return `${this.fcontId}_${this.launchType}`;
      }
    },
    selectCategoryId: function () {
      if (this.contentType == CONTENT_TYPE.designpaperPremiumCollection) {
        return this.categoryId
      }else {
        if (this.fcontId == LATEST_DESINGPAPER_ARTICLEID) {
          return DESIGNPAPER_CATEGORY_NEW
        }else {
          return DESIGNPAPER_CATEGORY_ALL
        }
      }
    },
    selectOpenUrl: function () {
      const query = [
        { key: "content_type_id", value: this.contentType },
        { key: "group", value: this.selectCategoryId },
        { key: "MediaSizeId", value: this.mediaSizeId },
        { key: "MediaTypeId", value: this.mediaTypeId },
        { key: "article_id", value: this.articleLogId },
      ];
      const pram = query.map((q) => `${q.key}=${q.value}`).join("&");
      return `${URL_DOMAIN}/?${pram}`;
    },
    printOpenUrl: function () {
      let query = [
        { key: "content_type_id", value: this.contentType },
        { key: "group", value: this.categoryId },
        { key: "content_id", value: this.designId },
        { key: "MediaSizeId", value: this.mediaSizeId },
        { key: "MediaTypeId", value: this.mediaTypeId },
        { key: "article_id", value: this.articleLogId },
      ];
      const pram = query.map((q) => `${q.key}=${q.value}`).join("&");
      return `${URL_DOMAIN}/${PRINTINGLIST_PAGE}/?${pram}`;
    },
    recommendedEnvironmentsUrl: function () {
      let languageId = ""
      switch (this.lg2) {
        case 'c2':
          languageId = "cn"
          break;
        case 'zh':
          languageId = "tw"
          break;
        // アプリ非対応言語
        case 'id':
        case 'pl':
        case 'th':
        case 'tr':
        case 'sv':
        case 'ro':
        case 'el':
        case 'cs':
        case 'nn':
        case 'da':
        case 'fi':
        case 'hu':
        case 'uk':
        case 'ms':
          languageId = 'en'
          break;
        
        default:
          languageId = this.lg2
      }
      return `https://support.epson.net/appinfo/template/${languageId}/index.html`
      
    }
  },
  methods: {
    trackGa4GoAppEvent: function() {
      this.$gtag.event("go_app", {
        "app_name": "Template Collection",
        "article_no": this.fcontId,
        "print_type": this.launchType,
        "design_id": this.designId,
        "site_id": "gallery"
      })
    },
    launchApp: function () {
      this.trackGa4GoAppEvent()

      let openUrl = "";
      switch (this.launchType) {
        case LAUNCH_TYPE.select:
          openUrl = this.selectOpenUrl;
          break;
        case LAUNCH_TYPE.print:
          openUrl = this.printOpenUrl;
          break;
        default:
          openUrl = this.selectOpenUrl;
      }
      window.open(openUrl, '_blank')
      this.$log.debug("url", openUrl);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.app-message-area {
  text-align: center;
}

.app-message-1 {
  margin-bottom: 10px;
}

.app_title {
  margin: 10px 10px 0px 10px;
  display: inline-block;
  vertical-align: center;
}

.app_info {
  text-align: center;
  margin: 20px auto;
}

.app_info img {
  display: inline-block;
  max-width: 80px;
}

p.modal-print-button a {
  padding: 10px 5px;
  width: 100%;
  max-width: 300px;
}

.app-caution {
  background-color: #eaeaea;
  padding: 10px;
}

.app-caution p {
  position: relative;
  padding-left: 1.25em;
}
.app-caution p:before {
  position: absolute;
  content: "*";
  left: 0;
  top: 0;
}

.app-caution table {
  background-color: white;
}

/* スマホサイズのみ適用 */
@media screen and (max-width: 991px) {
  .app-caution p {
    font-size: 12px;
  }
}
</style>